import { render, staticRenderFns } from "./DDoS.vue?vue&type=template&id=35bf21b8&"
import script from "./DDoS.vue?vue&type=script&lang=js&"
export * from "./DDoS.vue?vue&type=script&lang=js&"
import style0 from "./DDoS.vue?vue&type=style&index=0&id=35bf21b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports